import { AsyncPipe, CommonModule, DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { CardModule } from 'primeng/card';
import { SectionItemComponent } from './components/section-item/section-item.component';
import { CarouselModule } from 'primeng/carousel';
import { DashboardService } from '../services/dashboard.service';
import { chunkArray, getFontSize } from '../utils/common.util';
import { interval, map, startWith, Subscription } from 'rxjs';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'emc-dashboard',
  imports: [
    CommonModule,
    FormsModule,
    CardModule,
    DatePipe,
    SectionItemComponent,
    CarouselModule,
    AsyncPipe,
    ButtonModule,
    DialogModule,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  countProject: number = 6;
  totalProject: number = 12;
  time = Date.now();
  projectStack: any[] = [];

  time$ = interval(1000).pipe(
    startWith(0),
    map(() => Date.now()),
  );

  viewportWidth = window.innerWidth;
  viewportHeight = window.innerHeight;
  dpr = window.devicePixelRatio;

  visible: boolean = false;
  bgUrl: string = '';

  private sub!: Subscription;
  private intervalTime = 4 * 60 * 1000;

  constructor(
    private dashboardService: DashboardService,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.initBasicData();
  }

  ngAfterViewInit() {
    this.getDashboardData();

    this.sub = interval(this.intervalTime).subscribe(() => {
      this.initBasicData();
      this.getDashboardData();
      console.info('get data');
    });
  }

  initBasicData() {
    this.dashboardService.getBgImage().subscribe({
      next: (res: any) => {
        if (res && res.data) {
          const { display_url, displayUrl } = res.data;
          this.applyBg(display_url ?? displayUrl);
        }
      },
    });
    this.totalProject = this.projectStack.length;
    this.applyFontSize();
  }

  applyFontSize() {
    const fontSize = getFontSize(this.viewportWidth, this.dpr);
    document.documentElement.style.fontSize = `${fontSize}px`;
  }

  applyBg(display_url: string) {
    const dashboard = document.querySelector('.dashboard') as HTMLElement;
    if (dashboard) {
      dashboard.style.backgroundImage = `url('${display_url}')`;
    }
  }

  changeBackground() {
    this.visible = false;
    this.dashboardService.postBgImage(this.bgUrl).subscribe({
      next: (res: any) => {
        this.applyBg(this.bgUrl);
      },
    });
  }

  getDashboardData() {
    this.dashboardService.getDashboardData().subscribe({
      next: (res: any) => {
        const { data } = res;
        if (data) {
          this.totalProject = data.length;
          const assignees = data
            .flatMap((d: any) => d.tasks ?? [])
            .flatMap((t: any) => t.assignees ?? []);

          assignees
            .filter((a: any) => a?.profile_photo_url ?? a?.profilePhotoUrl)
            .forEach((a: any) => {
              if (this.dashboardService.getCacheImage(a.id)) {
                a.profile_photo_url_base64 =
                  this.dashboardService.getCacheImage(a.id);
              } else {
                this.dashboardService.getUserImageByUserId(a.id).subscribe({
                  next: (res: any) => {
                    if (res && res.photo) {
                      a.profile_photo_url_base64 = res.photo;
                      this.dashboardService.setCacheImage(a.id, res.photo);
                    } else {
                      a.profile_photo_url_base64 = 'https://picsum.photos/200';
                      this.dashboardService.setCacheImage(
                        a.id,
                        'https://picsum.photos/200',
                      );
                    }
                  },
                  error: () => {
                    a.profile_photo_url_base64 = 'https://picsum.photos/200';
                    this.dashboardService.setCacheImage(
                      a.id,
                      'https://picsum.photos/200',
                    );
                  },
                });
              }
            });
          this.projectStack = chunkArray(data);
        }
      },
    });
  }

  logout() {
    this.projectStack = [];
    this.authService.logout();
  }
}
